import { default as common } from "./common.json";

const it = { common };

export default it;
